export const ALL_PLANS = {
	pl: [
		{
			name: 'BASIC',
			price: '59.97 PLN',
			tokens: '1000 Tokens',
			features: '1 month access',
			isPopular: false,
		},
		{
			name: 'PRO',
			price: '119.97 PLN',
			tokens: '3000 Tokens',
			features: '3 months access',
			isPopular: false,
		},
		{
			name: 'PREMIUM',
			price: '179.97 PLN',
			tokens: '6000 Tokens',
			features: '6 months access',
			isPopular: true,
		},
	],
	en: [
		{
			name: 'BASIC',
			price: '59.97 PLN',
			tokens: '1000 Tokens',
			features: '1 month access',
			isPopular: false,
		},
		{
			name: 'PRO',
			price: '119.97 PLN',
			tokens: '3000 Tokens',
			features: '3 months access',
			isPopular: false,
		},
		{
			name: 'PREMIUM',
			price: '179.97 PLN',
			tokens: '6000 Tokens',
			features: '6 months access',
			isPopular: true,
		},
	],
	de: [
		{
			name: 'BASIC',
			price: '14.99 €',
			tokens: '1000 Tokens',
			features: '1 month access',
			isPopular: false,
		},
		{
			name: 'PRO',
			price: '29.99 €',
			tokens: '3000 Tokens',
			features: '3 months access',
			isPopular: false,
		},
		{
			name: 'PREMIUM',
			price: '44.99 €',
			tokens: '6000 Tokens',
			features: '6 months access',
			isPopular: true,
		},
	],
	cs: [
		{
			name: 'BASIC',
			price: '349 Kč',
			tokens: '1000 Tokens',
			features: '1 month access',
			isPopular: false,
		},
		{
			name: 'PRO',
			price: '699 Kč',
			tokens: '3000 Tokens',
			features: '3 months access',
			isPopular: false,
		},
		{
			name: 'PREMIUM',
			price: '1090 Kč',
			tokens: '6000 Tokens',
			features: '6 months access',
			isPopular: true,
		},
	],
};
